import { BaseApiService } from '@services/baseApiService';
import { ProcessRoleOutputDTO } from '@types';

export const processRoleService = new BaseApiService<ProcessRoleOutputDTO>('processroles'); 